import React, { useEffect, useState } from 'react'

export default function Grupos(props) {
    const [nombre, setNombre] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [esActivo, setActivo] = useState('')

    useEffect(() => {
        if (props.formData.data) {
            const datForm = props.formData.data
            setNombre(datForm["nombreGrupo"])
            setDescripcion(datForm["descripcionGrupo"])
            setActivo(datForm["esActivo"])
        } else {
            setNombre(localStorage.getItem("nombreGroup"))
            setDescripcion(localStorage.getItem("descGroup"))
            setActivo(localStorage.getItem("activGrp"))
        }
    }, [props])

    return (
        <div className="row justify-content-center">
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Nombre</label>
                            <input
                                id="nombre"
                                name="nombre"
                                type="text"
                                maxLength={100}
                                value={nombre}
                                onChange={e => {
                                    setNombre(e.target.value)
                                    localStorage.setItem('nombreGroup', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Descripción</label>
                            <input
                                id="descripcion"
                                name="descripcion"
                                maxLength={200}
                                value={descripcion}
                                onChange={e => {
                                    setDescripcion(e.target.value)
                                    localStorage.setItem('descGroup', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar Descripción"
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Estado</label>
                            <select
                                className="form-control"
                                id="estado"
                                name="estado"
                                value={esActivo} // Sincronización del estado con el select
                                onChange={(e) => setActivo(e.target.value)} // Actualización del estado
                            >
                                <option value="">Seleccionar estado</option>
                                <option value="S">Activo</option>
                                <option value="N">Inactivo</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
